import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Nyhedsbrev = () => {
  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Nyhedsbrev: Seneste nyt om privat- og erhvervsøkonomi</title>
        <meta name="description" content="Tilmeld dig nyhedsbrevet og hold dig informeret om de seneste nyheder inden for økonomi og vores mange arrangementer. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-3xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Nyhedsbrev</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 break-words">Nyhedsbrev</h1>
        
        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            Få information, tips og tricks om den seneste udvikling inden for privatøkonomi og investering.
          </p>
        </div>

        <div className="bg-slate-50 rounded-3xl p-5 md:p-12 border border-slate-200 shadow-sm">
          <div className="flex items-center mb-8">
            <h2 className="text-2xl font-bold text-slate-900">Tilmeld dig vores nyhedsbrev her</h2>
          </div>

          <form className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-bold text-slate-700 mb-2">
                Din E-mailadresse:
              </label>
              <input
                type="email"
                id="email"
                required
                className="w-full px-4 py-4 rounded-xl border border-slate-300 focus:ring-2 focus:ring-[#b60f00] focus:border-[#b60f00] outline-none transition-all"
                placeholder="navn@eksempel.dk"
              />
            </div>

            {/* Honeypot field for anti-spam */}
            <div className="sr-only absolute" aria-hidden="true">
              <label htmlFor="website_url">Website URL</label>
              <input type="text" id="website_url" name="website_url" tabIndex="-1" autoComplete="off" />
            </div>

            <button
              type="submit"
              className="w-full bg-[#b60f00] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-md active:scale-95 flex items-center justify-center"
            >
              Tilmeld nyhedsbrev
            </button>
            
            <p className="text-xs text-slate-500 text-center mt-4">
              Ved at tilmelde dig accepterer du at modtage e-mails fra Finansoptimering. Du kan til enhver tid afmelde dig igen.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Nyhedsbrev;
